import { Link } from 'react-router-dom';

const snsLinks = [
  {
    label: '인스타그램',
    href: '#',
    icon: 'ri-instagram-line',
    hoverColor: 'hover:bg-gradient-to-br hover:from-pink-500 hover:to-orange-400 hover:border-pink-400',
  },
  {
    label: '유튜브',
    href: '#',
    icon: 'ri-youtube-line',
    hoverColor: 'hover:bg-red-600 hover:border-red-500',
  },
  {
    label: '틱톡',
    href: '#',
    icon: 'ri-tiktok-line',
    hoverColor: 'hover:bg-black hover:border-white/40',
  },
  {
    label: 'X (트위터)',
    href: '#',
    icon: 'ri-twitter-x-line',
    hoverColor: 'hover:bg-zinc-800 hover:border-white/40',
  },
  {
    label: '카카오톡',
    href: '#',
    icon: 'ri-kakao-talk-line',
    hoverColor: 'hover:bg-yellow-400 hover:border-yellow-300 hover:text-black',
  },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { label: '홈', path: '/' },
    { label: '점성술', path: '/astrology' },
    { label: '사주팔자', path: '/four-pillars' },
    { label: '운세 리포트', path: '/live-report' },
    { label: '유명인 사주', path: '/celebrity-saju' },
    { label: '블로그', path: '/blog' },
    { label: 'Destiny GPT란?', path: '/about' },
    { label: '토큰 충전', path: '/checkout' },
  ];

  return (
    <footer className="relative bg-primary-navy/50 backdrop-blur-xl border-t border-white/10 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12 mb-10">
          {/* Brand Section */}
          <div className="text-center md:text-left">
            <Link to="/" className="inline-flex items-center space-x-2 mb-4 group">
              <div className="relative w-11 h-11 flex-shrink-0">
                <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-primary-gold/30 to-amber-600/10 blur-md group-hover:blur-xl group-hover:from-primary-gold/50 transition-all duration-500"></div>
                <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-[#1a0f2e] to-[#0f0a1e] border border-primary-gold/60 group-hover:border-primary-gold transition-all duration-300"></div>
                <div className="absolute top-1 left-1 w-2.5 h-2.5 border-t-2 border-l-2 border-primary-gold/70 rounded-tl"></div>
                <div className="absolute top-1 right-1 w-2.5 h-2.5 border-t-2 border-r-2 border-primary-gold/70 rounded-tr"></div>
                <div className="absolute bottom-1 left-1 w-2.5 h-2.5 border-b-2 border-l-2 border-primary-gold/70 rounded-bl"></div>
                <div className="absolute bottom-1 right-1 w-2.5 h-2.5 border-b-2 border-r-2 border-primary-gold/70 rounded-br"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span
                    className="text-primary-gold text-xl font-bold leading-none select-none"
                    style={{ fontFamily: '"Noto Serif KR", "Noto Serif", serif', textShadow: '0 0 10px rgba(251,191,36,0.7)' }}
                  >
                    命
                  </span>
                </div>
              </div>
              <span className="text-2xl font-bold text-gradient font-display">DESTINY GPT</span>
            </Link>
            <p className="text-sm text-purple-300 leading-relaxed mb-5">
              점성술과 사주로 당신의 운명을 읽고<br />
              미래를 예측하는 AI 운세 서비스
            </p>

            {/* SNS Icons */}
            <div>
              <p className="text-xs text-purple-400/70 uppercase tracking-widest mb-3 font-medium">Follow Us</p>
              <div className="flex items-center justify-center md:justify-start flex-wrap gap-2">
                {snsLinks.map((sns) => (
                  <a
                    key={sns.label}
                    href={sns.href}
                    aria-label={sns.label}
                    title={sns.label}
                    className={`group/sns relative w-10 h-10 flex items-center justify-center rounded-xl bg-white/5 border border-white/10 text-purple-300 hover:text-white transition-all duration-300 cursor-pointer ${sns.hoverColor}`}
                  >
                    <i className={`${sns.icon} text-base`}></i>
                    {/* Tooltip */}
                    <span className="absolute -top-8 left-1/2 -translate-x-1/2 bg-black/80 text-white text-[10px] px-2 py-1 rounded whitespace-nowrap opacity-0 group-hover/sns:opacity-100 transition-opacity duration-200 pointer-events-none">
                      {sns.label}
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-bold text-white mb-4">빠른 링크</h3>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-purple-300 hover:text-primary-gold transition-colors duration-300 inline-flex items-center space-x-1 group"
                  >
                    <i className="ri-arrow-right-s-line text-xs opacity-0 group-hover:opacity-100 -ml-4 group-hover:ml-0 transition-all duration-300"></i>
                    <span>{link.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-bold text-white mb-4">문의하기</h3>
            <ul className="space-y-3 mb-5">
              <li className="flex items-center justify-center md:justify-start space-x-2 text-sm text-purple-300">
                <i className="ri-mail-line text-primary-gold"></i>
                <span>support@destinygpt.com</span>
              </li>
              <li className="flex items-center justify-center md:justify-start space-x-2 text-sm text-purple-300">
                <i className="ri-time-line text-primary-gold"></i>
                <span>평일 09:00 - 18:00</span>
              </li>
              <li className="flex items-center justify-center md:justify-start space-x-2 text-sm text-purple-300">
                <i className="ri-question-line text-primary-gold"></i>
                <span>자주 묻는 질문 (FAQ)</span>
              </li>
            </ul>

            {/* Newsletter / Notification */}
            <div className="rounded-xl bg-white/5 border border-white/10 p-4">
              <p className="text-xs text-primary-gold font-semibold mb-1 tracking-wide">운세 알림 받기</p>
              <p className="text-xs text-purple-400 mb-3">매일 오전, 오늘의 운세를 카카오로 받아보세요</p>
              <a
                href="#"
                className="inline-flex items-center justify-center gap-1.5 w-full py-2 rounded-lg bg-yellow-400/20 border border-yellow-400/30 text-yellow-300 hover:bg-yellow-400/30 transition-all duration-300 text-xs font-medium cursor-pointer whitespace-nowrap"
              >
                <i className="ri-kakao-talk-line"></i>
                카카오 채널 추가
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
            <p className="text-sm text-purple-400 text-center sm:text-left">
              © {currentYear} DESTINY GPT. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm text-purple-400">
              <a href="#" className="hover:text-primary-gold transition-colors duration-300">
                이용약관
              </a>
              <a href="#" className="hover:text-primary-gold transition-colors duration-300">
                개인정보처리방침
              </a>
              <a href="#" className="hover:text-primary-gold transition-colors duration-300">
                사업자정보
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-primary-gold to-transparent opacity-50"></div>
    </footer>
  );
}